import script from "./ComProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComProfile.vue?vue&type=script&setup=true&lang=ts"

import "./ComProfile.vue?vue&type=style&index=0&id=6b3121ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b3121ac"]])

export default __exports__